export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const SET_DATA_LIST = "SET_DATA_LIST";
export const SET_TOTAL = "SET_TOTAL";
export const SET_VEHICLE_USAGE_REQUIREMENT_BY_LICENSE_CLASS = "SET_VEHICLE_USAGE_REQUIREMENT_BY_LICENSE_CLASS";
export const SET_VEHICLE_BY_INSTRUCTOR_AND_USAGE_AND_LICENSE_CLASS = "SET_VEHICLE_BY_INSTRUCTOR_AND_USAGE_AND_LICENSE_CLASS";
export const SET_VEHICLE_BY_CURRENT_INSTRUCTOR = "SET_VEHICLE_BY_CURRENT_INSTRUCTOR";
